// extracted by mini-css-extract-plugin
export default {"restore-files-button":"restore-files-section_restore-files-button__1mze8"};